module.exports = __webpack_public_path__ + "static/media/booking.029917ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/travel/booking.jpg
// module id = 748
// module chunks = 0